import { render } from "./Dialog.vue?vue&type=template&id=fa8e8baa&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=fa8e8baa&scoped=true&lang=css"

import exportComponent from "G:\\Graduation project\\notemd\\FrontEnd\\notemd-web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_29d074f7dbbfd97370df878da6275bc8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa8e8baa"]])

export default __exports__